//
import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import colors from '../../colors';
import { TextInput } from 'react-native-paper';
import { TextInputProps } from 'react-native-paper/lib/typescript/src/components/TextInput/TextInput';

type Props = Omit<TextInputProps, 'theme'> & { theme?: any };

const CTextInput: React.FC<Props> = (props) => {
  const { style, label, ...other } = props;

  return <TextInput label={label} style={[style, { height: label ? undefined : 45 }]} {...other} />;
};

// const styles = StyleSheet.create({
//   divider: {
//     height: 1,
//     backgroundColor: colors.divider,
//     width: '100%'
//   }
// });

export default CTextInput;
